import { useEffect, useState } from "react";

import { MILLISECONDS_PER_SECOND } from "@/pages/UpdateEmail/constants";

const getSecondsLeft = (deadline: number | null): number => {
  if (!deadline) {
    return 0;
  }

  return Math.max(0, Math.ceil((deadline - Date.now()) / MILLISECONDS_PER_SECOND));
};

/**
 * Counts down to an absolute timestamp rather than from a duration, so the value stays correct
 * across a re-render or a tab that was backgrounded while the timer was throttled. The remaining
 * seconds are derived during render rather than stored, so a new deadline is never read through a
 * value left over from the previous one; the interval only exists to trigger the next render.
 */
const useDeadlineCountdown = (deadline: number | null): number => {
  const [, setStateTick] = useState(0);

  useEffect(() => {
    if (!deadline) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      const secondsLeft = getSecondsLeft(deadline);
      setStateTick(secondsLeft);

      if (secondsLeft <= 0) {
        window.clearInterval(intervalId);
      }
    }, MILLISECONDS_PER_SECOND);

    return () => window.clearInterval(intervalId);
  }, [deadline]);

  return getSecondsLeft(deadline);
};

export default useDeadlineCountdown;
